import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  ["Task", "Hours per Day"],
  ["Online Advertising", 11],
  ["Conversation", 6],
  ["Print Advertising", 7],
  ["Sales Training", 2],
];

export const options = {
  title: "Marketing Budget",
};

export function PieChart() {
  return (
    <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"400px"}
    />
  );
}
